// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"939":"b8a6ce43","3227":"27fe4eb7"}[chunkId] + ".css";
};